import { combineReducers } from 'redux';
import Interview from './interviewReducer';
import Meet from './meetReducer';
const appReducer = combineReducers({ Interview, Meet });

const reducers = (state, action) => {
    return appReducer(state, action);
};

export default reducers;
